import { Component } from "react";
import { Input, Form, Select, Radio, Checkbox, DatePicker, Space } from "antd";
import { getOptionArray, selectFilterOption, getRadioArray, modalFromLayout } from "@/lib/antdElementFunction";
import { getStorage } from "@/lib/webStorage";
import { ReRangePicker } from "@/components/refineElement";
import { getMoment, startTimeToday, endTimeToday, getCurrentTime, dateFormat } from "@/lib/dateTime";
import { getLangList } from '@/lib/i18n';

interface props {
  form?: any;
  leaveInfo: any;
  handleType: string;
  allStudent: any;
  intervalArray: any;
}

interface state {
  userAccountIdDataArray: Array<object>;
  isRepeat: boolean;
}

class ModalLeave extends Component<props, state> {
  state = {
    userAccountIdDataArray: [],
    isRepeat: false,
  };
  leaveT: any = getLangList("leave");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { form, leaveInfo, handleType } = this.props;
    const {
      startTime,
      endTime,
      leaveType,
      leaveDescription,
    } = leaveInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({
        date: [getMoment(startTime), getMoment(endTime)],
        leaveType,
        leaveDescription,
      });
    } else if (handleType === 'create') {
      this.getUserAccountIdDataArray();
    }
  }

  getUserAccountIdDataArray = () => {
    const { allStudent } = this.props;
    const userAccountIdDataArray = allStudent.map((item: any) => {
      const { nameCn, nameEn, className, userAccountId } = item;
      return { value: userAccountId, label: `${nameCn}-${nameEn}-${className}` }
    });
    this.setState({ userAccountIdDataArray });
  }

  onChangeStudent = (value: any) => {
    const { allStudent, intervalArray, form } = this.props;
    const currentTime = getCurrentTime();
    const studentInfo = allStudent?.find((item: any) => item.userAccountId === value) ?? {};
    const intervalInfo = intervalArray?.find((item: any) => item.timePeriodName === studentInfo.timePeriodName) ?? {};
    const { startTime, endTime } = intervalInfo;
    const intervalStart = `${currentTime.format(dateFormat)} ${startTime}:00`;
    const intervalEnd = `${currentTime.format(dateFormat)} ${endTime}:00`;
    form.setFieldsValue({
      date: [getMoment(intervalStart), getMoment(intervalEnd)],
    });
  }

  onChangeCheckbox = (itemArray: any[]) => {
    this.setState({ isRepeat: itemArray.length > 0 });
  };

  render() {
    const { form, handleType } = this.props;
    const { userAccountIdDataArray, isRepeat } = this.state;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          date: [startTimeToday, endTimeToday],
          recurrenceDays: [],
          recurrenceType: 1,
          recurrenceEndDate: endTimeToday,
          leaveType: 'sick',
          leaveDescription: '',
          updateType: 1,
        }}
      >
        {(handleType === 'create' && +getStorage("roleId") !== 2) &&
          <Form.Item
            label={this.leaveT.STUDENT}
            name="userAccountId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input: any, option: any) => selectFilterOption(input, option)}
              onChange={this.onChangeStudent}
            >
              {getOptionArray(userAccountIdDataArray)}
            </Select>
          </Form.Item>
        }

        <Form.Item label={this.leaveT.TIME} name="date">
          <ReRangePicker format='dateTimeFormat4' />
        </Form.Item>

        <Form.Item label={this.leaveT.REPEAT_DATE} name="recurrenceDays">
          <Checkbox.Group onChange={this.onChangeCheckbox}>
            <Checkbox value={1}>一</Checkbox>
            <Checkbox value={2}>二</Checkbox>
            <Checkbox value={3}>三</Checkbox>
            <Checkbox value={4}>四</Checkbox>
            <Checkbox value={5}>五</Checkbox>
            <Checkbox value={6}>六</Checkbox>
            <Checkbox value={7}>日</Checkbox>
          </Checkbox.Group>
        </Form.Item>

        {isRepeat &&
          <Form.Item label={this.leaveT.REPEAT_DATE_END} name="recurrenceType">
            <Radio.Group>
              <Radio value={1}>{this.leaveT.REPEAT_INFINTY}</Radio>
              <Radio value={2}>
                <Space>
                  {this.leaveT.REPEAT_TO}
                  <Form.Item style={{ marginBottom: "0" }} name="recurrenceEndDate">
                    <DatePicker disabledDate={(current: any) => current < endTimeToday} allowClear={false} />
                  </Form.Item>
                </Space>
              </Radio>
            </Radio.Group>
          </Form.Item>
        }

        {handleType === 'update' && isRepeat &&
          <Form.Item label={this.buttonT.UPDATE} name="updateType">
            <Radio.Group>
              {getRadioArray([
                { value: 1, label: this.leaveT.DELETE_OPTION_2 },
                { value: 2, label: this.leaveT.DELETE_OPTION_3 },
              ])}
            </Radio.Group>
          </Form.Item>
        }

        <Form.Item label={this.leaveT.LEAVE_TYPE} name="leaveType">
          <Radio.Group>
            {getRadioArray([
              { value: 'sick', label: this.leaveT.SICK },
              { value: 'personal', label: this.leaveT.PERSONAL },
              { value: 'other', label: this.leaveT.OTHER },
            ])}
          </Radio.Group>
        </Form.Item>

        <Form.Item label={this.leaveT.REASON} name="leaveDescription">
          <Input.TextArea rows={4} style={{ width: "100%" }} />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalLeave;